const routes = [
  {
    path: '',
    component: () =>
      import(
        '@/views/provider/massiveCertificationLoad/CertificationLoadWrapper.vue'
      ),
    children: [
      {
        path: '/provider/massiveCertificationLoad',
        name: 'MassiveCertificationLoad',
        component: () =>
          import(
            '@/views/provider/massiveCertificationLoad/MassiveCertificationLoad.vue'
          ),
      },
    ],
  },
];

export default routes;
